<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-primary ml-auto" style="z-index: 9999; position: relative;">
        <a class="navbar-brand" href="https://dailylife.xin" style="color: white;">生活居/首頁</a>
        
        <!-- 純自定義按鈕，無 Bootstrap 數據屬性 -->
        <button class="navbar-toggler" type="button" @click="manualToggleNavbar">
            <span class="navbar-toggler-icon"></span>
        </button>
        
        <!-- 不使用 Bootstrap collapse 類，僅通過自定義樣式控制顯示/隱藏 -->
        <div class="navbar-menu" :class="{ 'navbar-menu-open': isNavbarOpen }">
            <ul class="navbar-nav">
                <!-- <li class="nav-item">
                    <a class="nav-link" href="#" style="color: white;">待播歌曲</a>
                    <router-link class="nav-link" active-class="active" to ="/testpinia" style="color: white;">待播歌曲</router-link>
                </li> -->
                <li class="nav-item">
                    <!-- <a class="nav-link" href="#" style="color: white;">歌號點歌</a> -->
                    <router-link class="nav-link" active-class="active" to ="/songsearch" style="color: white;" @click="closeAllMenus">歌號點歌</router-link>
                </li>
                <li :class="['nav-item', 'dropdown', isMobile ? 'dropend' : '']">
                    <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" style="color: white;" @click="handleDropdownClick">歌星點歌</a>
                    <ul class="dropdown-menu">
                        <li class="dropdown-submenu">
                            <a class="dropdown-item dropdown-toggle" href="#" @click="handleSubmenuClick">台灣</a>
                            <ul class="dropdown-menu">
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'StarSongs', query: { param1: '台灣', param2: '男' } }" @click="closeAllMenus">男星</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'StarSongs', query: { param1: '台灣', param2: '女' } }" @click="closeAllMenus">女星</router-link></li>
                                                            
                            </ul>
                        </li>
                        <li class="dropdown-submenu">
                            <!-- <a class="dropdown-item dropdown-toggle" href="#">港粵</a> -->
                            <a class="dropdown-item dropdown-toggle" href="#" @click="handleSubmenuClick">港粵</a>
                            <ul class="dropdown-menu">
                                <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'StarSongs', query: { param1: '香港', param2: '男' } }" @click="closeAllMenus">男星</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'StarSongs', query: { param1: '香港', param2: '女' } }" @click="closeAllMenus">女星</router-link></li>
                                
                            </ul>
                        </li>
                        <li class="dropdown-submenu">
                            <!-- <a class="dropdown-item dropdown-toggle" href="#">大陸</a> -->
                            <a class="dropdown-item dropdown-toggle" href="#" @click="handleSubmenuClick">大陸</a>
                            <ul class="dropdown-menu">
                                <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'StarSongs', query: { param1: '大陸', param2: '男' } }" @click="closeAllMenus">男星</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'StarSongs', query: { param1: '大陸', param2: '女' } }" @click="closeAllMenus">女星</router-link></li>
                            </ul>
                        </li>
                        <li class="dropdown-submenu">
                            <!-- <a class="dropdown-item dropdown-toggle" href="#">星馬泰</a> -->
                            <a class="dropdown-item dropdown-toggle" href="#" @click="handleSubmenuClick">星馬泰</a>
                            <ul class="dropdown-menu">
                                <!-- <li><a class="dropdown-item" href="#">男星</a></li>
                                <li><a class="dropdown-item" href="#">女星</a></li> -->
                                <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'StarSongs', query: { param1: '星馬泰', param2: '男' } }" @click="closeAllMenus">男星</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'StarSongs', query: { param1: '星馬泰', param2: '女' } }" @click="closeAllMenus">女星</router-link></li>
                            </ul>
                        </li>
                                                
                    </ul>
                </li>
                <!-- 下拉式選單 Dropdown -->
                <li :class="['nav-item', 'dropdown', isMobile ? 'dropend' : '']">
                    <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" style="color: white;" @click="handleDropdownClick">字劃點歌</a>

                    <!-- 下拉式選單選項 Dropdown items -->
                    <ul class="dropdown-menu">
                        <li class="dropdown-submenu">
                            <a class="dropdown-item dropdown-toggle" href="#" @click="handleSubmenuClick">國語</a>
                            <ul class="dropdown-menu">
                                <!-- <li><a class="dropdown-item" href="#">一字部</a></li> -->
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '國語', param2: 1 } }" @click="closeAllMenus">一字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '國語', param2: 2 } }" @click="closeAllMenus">二字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '國語', param2: 3 } }" @click="closeAllMenus">三字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '國語', param2: 4 } }" @click="closeAllMenus">四字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '國語', param2: 5 } }" @click="closeAllMenus">五字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '國語', param2: 6 } }" @click="closeAllMenus">六字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '國語', param2: 7 } }" @click="closeAllMenus">七字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '國語', param2: 8 } }" @click="closeAllMenus">八字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '國語', param2: 9 } }" @click="closeAllMenus">九字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '國語', param2: 10 } }" @click="closeAllMenus">十字部以上</router-link></li>
                                
                                                               
                            </ul>
                        </li>    
                        <li class="dropdown-submenu">
                            <a class="dropdown-item dropdown-toggle" href="#" @click="handleSubmenuClick">台語</a>
                            <ul class="dropdown-menu">

                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '台語', param2: 1 } }" @click="closeAllMenus">一字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '台語', param2: 2 } }" @click="closeAllMenus">二字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '台語', param2: 3 } }" @click="closeAllMenus">三字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '台語', param2: 4 } }" @click="closeAllMenus">四字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '台語', param2: 5 } }" @click="closeAllMenus">五字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '台語', param2: 6 } }" @click="closeAllMenus">六字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '台語', param2: 7 } }" @click="closeAllMenus">七字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '台語', param2: 8 } }" @click="closeAllMenus">八字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '台語', param2: 9 } }" @click="closeAllMenus">九字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '台語', param2: 10 } }" @click="closeAllMenus">十字部以上</router-link></li>
                                                                                                
                            </ul>
                        </li>    
                        <li class="dropdown-submenu">
                            <a class="dropdown-item dropdown-toggle" href="#" @click="handleSubmenuClick">粵語</a>
                            <ul class="dropdown-menu">

                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '粵語', param2: 1 } }" @click="closeAllMenus">一字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '粵語', param2: 2 } }" @click="closeAllMenus">二字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '粵語', param2: 3 } }" @click="closeAllMenus">三字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '粵語', param2: 4 } }" @click="closeAllMenus">四字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '粵語', param2: 5 } }" @click="closeAllMenus">五字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '粵語', param2: 6 } }" @click="closeAllMenus">六字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '粵語', param2: 7 } }" @click="closeAllMenus">七字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '粵語', param2: 8 } }" @click="closeAllMenus">八字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '粵語', param2: 9 } }" @click="closeAllMenus">九字部</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to="{ name: 'SongList', query: { param1: '粵語', param2: 10 } }" @click="closeAllMenus">十字部以上</router-link></li>
                                                                               
                            </ul>
                        </li>
                        </ul>


                </li>
                <li :class="['nav-item', 'dropdown', isMobile ? 'dropend' : '']">
                    <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" style="color: white;" @click="handleDropdownClick"> 精選歌曲</a>
                    <ul class="dropdown-menu">
                        <li class="dropdown-submenu"><a class="dropdown-item dropdown-toggle" href="#" @click="handleSubmenuClick">排行歌曲</a>
                            <ul class="dropdown-menu">
                                <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'featuredsongs', query: { param1: 'A', param2: 'A' } }" @click="closeAllMenus">排行歌曲-國語</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'featuredsongs', query: { param1: 'A', param2: 'B' } }" @click="closeAllMenus">排行歌曲-台語</router-link></li>
                                <!-- <li><a class="dropdown-item" href="#">男星</a></li>
                                <li><a class="dropdown-item" href="#">女星</a></li> -->
                            </ul>
                        </li>
                        <li class="dropdown-submenu"><a class="dropdown-item dropdown-toggle" href="#" @click="handleSubmenuClick">新進歌曲</a>
                            <ul class="dropdown-menu">
                                <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'featuredsongs', query: { param1: 'B', param2: 'A' } }" @click="closeAllMenus">新進歌曲-國語</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'featuredsongs', query: { param1: 'B', param2: 'B' } }" @click="closeAllMenus">新進歌曲-台語</router-link></li>
                                <!-- <li><a class="dropdown-item" href="#">男星</a></li>
                                <li><a class="dropdown-item" href="#">女星</a></li> -->
                            </ul>
                        </li>
                        <li class="dropdown-submenu"><a class="dropdown-item dropdown-toggle" href="#" @click="handleSubmenuClick">熱唱歌曲</a>
                            <ul class="dropdown-menu">
                                <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'featuredsongs', query: { param1: 'C', param2: 'A' } }" @click="closeAllMenus">熱唱歌曲-國語</router-link></li>
                                <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'featuredsongs', query: { param1: 'C', param2: 'B' } }" @click="closeAllMenus">熱唱歌曲-台語</router-link></li>
                                <!-- <li><a class="dropdown-item" href="#">男星</a></li>
                                <li><a class="dropdown-item" href="#">女星</a></li> -->
                            </ul>
                        </li>
                        <!-- <li class="dropdown-submenu"><a class="dropdown-item dropdown-toggle" href="#">我的最愛</a> -->
                            <li><router-link class="dropdown-item" active-class="active" to ="/editmyfavorite" style="color: white;" @click="closeAllMenus">編輯最愛</router-link> </li>
                            <!-- 暂时隐藏充值功能 -->
                            <!-- <li v-show="false"><router-link class="dropdown-item" active-class="active" to ="/recharge" style="color: white;" @click="closeAllMenus">充值</router-link> </li> -->
                            <li><router-link class="dropdown-item" active-class="active" to ="/setup" style="color: white;" @click="closeAllMenus">設定</router-link> </li>
                            <!-- <ul class="dropdown-menu"> -->
                                <!-- <li><a class="dropdown-item" href="#">男星</a></li> -->
                                <!-- <li><router-link class="dropdown-item" active-class="active" :to ="{ name: 'featuredsongs', query: { param1: 'D', param2: 'A' } }">我的最愛</router-link></li> -->
                                <!-- <li><router-link class="dropdown-item" active-class="active" to ="/login" style="color: white;">登錄login</router-link></li> -->
                                <!-- <router-link class="nav-link" active-class="active" to ="/carousel" style="color: white;">Carousel</router-link> -->
                                <!-- <li><a class="dropdown-item" href="#">女星</a></li> -->
                            <!-- </ul> -->
                        
                                                
                    </ul>
                </li>

                <li class="nav-item-button"><button @click="addToFavorite" class="nav-link btn-favorite" active-class="active" style="color: white;">加入最愛</button>
                </li>

                <!-- <li><router-link class="nav-link" active-class="active" to ="/login" style="color: white;">登錄login</router-link>
                </li> -->
                <!-- ====================================================== -->
                
                -->
            </ul>
            
            <!-- 用戶信息顯示 - 放在導航欄右側 -->
            <div class="ms-auto d-flex align-items-center">
                <div class="user-info" v-if="userStore.isLoggedIn">
                    <!-- <span class="username-display">ID：{{ userStore.user?.customer_id }} --點數：{{ userStore.user?.balance }}</span> -->
                    <span v-if="userStore.isLoggedIn" class="membership-status">
                        會員到期: {{ formatDate(expiredDate) }}
                        <span v-if="remainingDays <= 7" class="expiring-soon">
                          (過期 {{ remainingDays }} 天)
                        </span>
                    </span>
                    <!-- 暂时隐藏登出按钮 -->
                    <!-- <button v-show="false" @click="handleLogout" class="btn-logout ms-2">
                        <i class="fas fa-sign-out-alt"></i> 登出
</button> -->
                </div>
                <!-- 暂时隐藏登入按钮 -->
                <!-- <div v-else v-show="false" class="login-link">
                    <button @click="showLoginModal" class="nav-link btn-link" style="color: white;">登入</button>
</div> -->
            </div>
        </div>
    </nav>
    <div>
        <AddMyFavorite ref="addFavoriteRef" />
    </div>
    
    <!-- 登入 Modal -->
    <div v-if="isLoginModalVisible" class="login-modal-container">
        <login @login-success="handleLoginSuccess" @close-modal="closeLoginModal" />
    </div>
</template>
  
<script setup>
    import { useRouter } from 'vue-router';
    import { ref, onMounted, computed, onUnmounted } from 'vue';
    import AddMyFavorite from './addmyfavorite.vue';
    import { useUserStore } from '../store/useUserStore';
    import axios from '../axios';
    import { getCookie } from '../utils/csrf.js';
    import login from './login.vue';

    const router = useRouter();
    const userStore = useUserStore();

    const handleClick = (routeName, query) => {
    router.push({ name: routeName, query: query });
    };

    const addFavoriteRef = ref(null);

    const addToFavorite = () => {
      console.log('嘗試添加當前播放歌曲到最愛');
      if (addFavoriteRef.value) {
        addFavoriteRef.value.addCurrentPlayingSong();
      } else {
        console.error('addFavoriteRef is null');
      }
    };

    const handleLogout = async () => {
      try {
        // 調用後端登出 API
        await axios.post('/logout/');
        
        // 清除前端存儲的用戶信息
        userStore.logout();
        
        // 可選：重新加載頁面或顯示提示
        window.location.reload();
      } catch (error) {
        console.error('登出失敗:', error);
        // 即使 API 調用失敗，也清除本地存儲
        userStore.logout();
        window.location.reload();
      }
    };

    const windowWidth = ref(window.innerWidth);
    const isMobile = computed(() => windowWidth.value < 992); // Bootstrap lg 斷點是 992px

    // 使用簡單的 Boolean ref 控制導航欄開合
    const isNavbarOpen = ref(false);
    
    // 純手動切換導航欄狀態
    const manualToggleNavbar = () => {
        isNavbarOpen.value = !isNavbarOpen.value;
    };
    
    // 修改關閉所有菜單的函數
    const closeAllMenus = () => {
        // 關閉所有下拉選單
        document.querySelectorAll('.dropdown-menu').forEach(menu => {
            menu.classList.remove('mobile-show');
        });
        
        // 關閉導航欄
        isNavbarOpen.value = false;
    };
    
    // 在窗口大小變化時關閉導航欄（如果在大屏幕上）
    const handleResize = () => {
        windowWidth.value = window.innerWidth;
        if (window.innerWidth >= 992) {
            isNavbarOpen.value = false;
        }
    };

    // 修改下拉選單點擊處理
    const handleDropdownClick = (event) => {
      if (isMobile.value) {
        // 阻止默認行為
        event.preventDefault();
        
        // 獲取目標元素
        const target = event.currentTarget;
        
        // 獲取下拉選單
        const dropdown = target.nextElementSibling;
        
        // 切換顯示/隱藏
        if (dropdown.classList.contains('mobile-show')) {
          dropdown.classList.remove('mobile-show');
        } else {
          // 先隱藏所有其他頂級下拉選單
          document.querySelectorAll('.nav-item > .dropdown-menu').forEach(menu => {
            menu.classList.remove('mobile-show');
          });
          
          dropdown.classList.add('mobile-show');
        }
      }
    };

    // 修改子選單點擊處理
    const handleSubmenuClick = (event) => {
      if (isMobile.value) {
        // 阻止默認行為
        event.preventDefault();
        event.stopPropagation();
        
        // 獲取目標元素
        const target = event.currentTarget;
        
        // 獲取子選單
        const submenu = target.nextElementSibling;
        
        // 切換顯示/隱藏
        if (submenu.classList.contains('mobile-show')) {
          // 如果已經顯示，則隱藏它和它的所有子選單
          submenu.classList.remove('mobile-show');
          submenu.querySelectorAll('.dropdown-menu').forEach(menu => {
            menu.classList.remove('mobile-show');
          });
        } else {
          // 先隱藏同級的其他子選單及其子選單
          const parentLi = target.closest('li');
          const parentUl = parentLi.closest('ul');
          parentUl.querySelectorAll('.dropdown-submenu > .dropdown-menu').forEach(menu => {
            if (menu !== submenu) {
              menu.classList.remove('mobile-show');
              menu.querySelectorAll('.dropdown-menu').forEach(submenu => {
                submenu.classList.remove('mobile-show');
              });
            }
          });
          
          // 顯示當前子選單
          submenu.classList.add('mobile-show');
        }
      }
    };

    // 在 onMounted 中添加事件監聽器
    onMounted(() => {
      if (userStore.isLoggedIn) {
        console.log('用戶已登入，獲取到期日期');
        fetchExpiredDate();
      } else {
        console.log('用戶未登入，監聽登入事件');
        // 監聽登入事件，登入後獲取到期日期
        userStore.$subscribe((mutation, state) => {
          if (state.user && !expiredDate.value) {
            console.log('用戶登入，獲取到期日期');
            fetchExpiredDate();
          }
        });
      }
      
      // 監聽會員更新事件
      window.addEventListener('membership-updated', () => {
        console.log('收到會員更新事件，重新獲取到期日期');
        fetchExpiredDate();
      });
      
      // 添加事件監聽器並初始化下拉選單
      window.addEventListener('resize', handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener('membership-updated', fetchExpiredDate);
      window.removeEventListener('resize', handleResize);
    });

    const isLoginModalVisible = ref(false);

    // 顯示登入 Modal
    const showLoginModal = () => {
      isLoginModalVisible.value = true;
      closeAllMenus(); // 關閉所有下拉選單
      // 發送事件通知 App.vue
      window.dispatchEvent(new CustomEvent('login-modal-show'));
    };

    // 關閉登入 Modal
    const closeLoginModal = () => {
      isLoginModalVisible.value = false;
      // 發送事件通知 App.vue
      window.dispatchEvent(new CustomEvent('login-modal-hide'));
    };

    // 登入成功後的處理
    const handleLoginSuccess = () => {
      closeLoginModal();
      // 可以添加其他登入成功後的邏輯，如重新加載用戶數據等
    };

    const expiredDate = ref(null)

    // 格式化日期
    const formatDate = (date) => {
      if (!date) return '未設置'
      return new Date(date).toLocaleDateString('zh-TW')
    }

    // 計算剩餘天數
    const remainingDays = computed(() => {
      if (!expiredDate.value) return 0
      const now = new Date()
      const expired = new Date(expiredDate.value)
      const diffTime = expired - now
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    })

    // 獲取用戶到期日期
    const fetchExpiredDate = async () => {
      if (!userStore.isLoggedIn) {
        console.log('用戶未登入，不獲取到期日期');
        return;
      }
      
      // 直接從 user 對象獲取 customer_id
      const customId = userStore.user?.customer_id;
      console.log('嘗試獲取用戶到期日期，用戶 ID:', customId);
      
      if (!customId) {
        console.error('無法獲取用戶 ID');
        return;
      }
      
      try {
        const url = `/customer/${customId}/expireddate/`;
        console.log('API 請求 URL:', url);
        
        const response = await axios.get(url);
        console.log('到期日期響應:', response.data);
        
        expiredDate.value = response.data.expireddate;
        console.log('設置到期日期:', expiredDate.value);
      } catch (error) {
        console.error('獲取到期日期失敗:', error);
        console.error('錯誤詳情:', error.response ? error.response.data : '無響應數據');
      }
    }
</script>
  
<style scoped>
/* 大屏幕上的 hover 行為 */
@media (min-width: 992px) {
  .navbar-nav li:hover > ul.dropdown-menu {
    display: block;
  }
  
  .dropdown-submenu:hover > .dropdown-menu {
    display: block;
  }
  
  .dropdown-submenu > .dropdown-menu {
    background-color: #6698e2;
    top: 0;
    left: 100%;
    margin-top: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding: 0;
  }
}

.dropdown-submenu {
  position: relative;
}

/* 手機模式下的樣式 */
@media (max-width: 991.98px) {
  /* 隱藏所有下拉選單 */
  .dropdown-menu {
    display: none;
    background-color: #6698e2;
    padding: 0;
    border: none;
    width: 100%;
    margin: 0;
    border-radius: 0;
  }
  
  /* 主選單樣式 */
  .nav-item.dropdown > .dropdown-menu {
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    z-index: 1000;
  }
  
  /* 子選單樣式 - 向右偏移 */
  .dropdown-submenu > .dropdown-menu {
    background-color: #5588d2; /* 稍微深一點的背景色 */
    position: absolute;
    left: 30%; /* 從父元素的 30% 開始 */
    top: 0;
    width: 70%; /* 寬度為 70% */
    z-index: 1001;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  }
  
  /* 孫選單樣式 - 更深的背景色和更多的右偏移 */
  .dropdown-submenu .dropdown-submenu > .dropdown-menu {
    background-color: #4477c1; /* 更深的背景色 */
    left: 35%; /* 更多的右偏移 */
    z-index: 1002; /* 更高的層級 */
  }
  
  /* 在較小的屏幕上進一步調整 */
  @media (max-width: 576px) {
    .dropdown-submenu > .dropdown-menu {
      left: 20%; /* 在更小的屏幕上減少左偏移 */
      width: 80%;
    }
    
    .dropdown-submenu .dropdown-submenu > .dropdown-menu {
      left: 25%;
      width: 75%;
    }
  }
  
  /* 顯示被標記為 mobile-show 的選單 */
  .dropdown-menu.mobile-show {
    display: block !important;
  }
  
  /* 調整下拉選單項目的樣式 */
  .dropdown-item {
    padding: 10px 15px;
    color: white;
  }
  
  /* 調整子選單標題的樣式 */
  .dropdown-submenu > a.dropdown-item {
    font-weight: bold;
  }
  
  /* 調整箭頭方向，指向右側 */
  .dropdown-submenu > a::after {
    display: inline-block;
    margin-left: 0.5em;
    vertical-align: middle;
    transform: rotate(-90deg); /* 箭頭指向右側 */
  }
}

/* 通用樣式 */
.dropdown-menu {
  background-color: #6698e2;
  padding: 0;
  border: none;
}

.dropdown-menu > li > a {
  color: white;
}

.dropdown-menu > li > a:hover {
  background-color: #419dda;
}

.user-info {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  /* 移除背景色 */
  /* background-color: rgba(255, 255, 255, 0.1); */
  border-radius: 4px;
  min-width: 200px; /* 增加寬度以適應更長的文本 */
  white-space: nowrap; /* 防止文本換行 */
  overflow: visible; /* 允許內容溢出 */
}

.username-display {
  color: white; /* 確保文字為白色 */
  font-size: 0.9rem;
  font-weight: bold;
  overflow: visible; /* 允許內容溢出 */
}

.login-link a {
  color: white;
  text-decoration: none;
}

.login-link a:hover {
  text-decoration: underline;
}

.debug-info {
  display: none; /* 隱藏調試信息 */
  color: yellow;
  font-size: 0.8rem;
  margin-top: 0.5rem;
}

/* 添加 Modal 容器樣式 */
.login-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999 !important; /* 設置比所有其他元素更高的 z-index */
}

/* 按鈕樣式，使其看起來像鏈接 */
.btn-link {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: none;
}

.btn-link:hover {
  text-decoration: underline;
}

/* 添加登出按鈕樣式 */
.btn-logout {
    background: none;
    border: none;
    color: white;
    padding: 4px 8px;
    font-size: 0.9rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    transition: all 0.3s ease;
}

.btn-logout:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
}

/* 調整用戶信息容器樣式 */
.user-info {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    min-width: 200px;
    white-space: nowrap;
}

.username-display {
    color: white;
    font-size: 0.9rem;
    font-weight: bold;
}

/* 自定義導航欄折疊樣式 */
.navbar-menu {
    display: flex;
    flex-basis: 100%;
}

@media (max-width: 991.98px) {
    .navbar-menu {
        display: none;
        flex-direction: column;
        width: 100%;
        background-color: #4d90fe;
        padding: 0.5rem 1rem;
    }
    
    .navbar-menu-open {
        display: flex !important;
    }
}

@media (min-width: 992px) {
    .navbar-menu {
        display: flex !important;
    }
}

/* 移除「加入最愛」按鈕的箭頭 */
.nav-item-button {
    list-style: none;
}

.btn-favorite {
    background: none;
    border: none;
    padding: 0.5rem 1rem;
}

.btn-favorite::after {
    display: none !important;
}

/* 確保所有偽元素都不顯示 */
li.nav-item-button::after,
li.nav-item-button::before,
.nav-item-button .nav-link::after,
.nav-item-button .nav-link::before {
    display: none !important;
    content: none !important;
}
</style>
